import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { CLAIM_ACTIVITY_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { makeInteger } from '../../../utils.js'
import '../Custom.css'
import { csvUrl, getData } from '../CustomUtils.js'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'

const CLAIM_ACTIVITY_REPORT = gql(CLAIM_ACTIVITY_REPORT_QUERY)

export default function HistoricalClaimActivityReport({ location }) {
  console.log('HistoricalClaimActivityReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, CLAIM_ACTIVITY_REPORT, 'claimActivityReport', setResults, setGraphQLErrors)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = []
    let totals = new Array(results.columnHeadings.length - 1) 
    for (let i = 0; i < totals.length; i++) {
      totals[i] = 0
    }
    for (let i = 0; i < results.reportData.length; i++) {
      let row = []
      for (let j = 0; j < results.reportData[i].length; j++) {
        if (j === 0) {
          row.push(<td key={j} style={{padding: '.25rem'}}><b>{results.reportData[i][j]}</b></td>)
        } else {
          row.push(<td key={j} style={{padding: '.25rem', textAlign: 'right'}}>{results.reportData[i][j]}</td>)
          totals[j-1] += makeInteger(results.reportData[i][j])
        }
      }
      resultRows.push(<tr key={i}>{row}</tr>)
    }
    const totalsRow = []
    totalsRow.push(<td key={-1} style={{padding: '.25rem'}}><b>TOTAL</b></td>)
    for (let i = 0; i < totals.length; i++) {
      totalsRow.push(<td key={i} style={{padding: '.25rem', textAlign: 'right'}}><b>{totals[i]}</b></td>)
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('HBFuller/claimActivityReport/claim_activity_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{padding: '.25rem', border: 'solid black 1px'}}>
          <ReportHeading title={'H.B. Fuller/TEC Historical Claim Activity Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            {resultRows}
            <tr>{totalsRow}</tr>
          </tbody>
        </Table>
      </div>
    )
  }
}